import { useQuery } from '@tanstack/react-query';
import financialService from 'v2/services/financial';

export const useListTransfers = () => {
  const { data, isFetching, error, refetch } = useQuery({
    queryKey: ['financial', 'transfers'],
    queryFn: () => financialService.listTransfers().toPromise()
  });

  return {
    data,
    isFetching,
    error,
    refetch
  };
};
